import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'src/components/ui/button';
import { SidebarMenuItems } from './SidebarMenuItems';
import './Sidebar.css';

const MainSidebar = ({ menuOpen = false, toggleMenu }) => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sidebar = (
    <div className={`sidebar-container-v2 partner-sidebar ${isMobile ? 'mobile-sidebar mobile-open' : ''}`}>
      <div className="sidebar-v2 pill-dashboard-mode">
        {isMobile && (
          <div className="sidebar-header-v2">
            <DialogPrimitive.Title className="font-sora font-semibold">Navegação</DialogPrimitive.Title>
            <Button variant="ghost" size="icon" aria-label="Fechar menu" onClick={toggleMenu}>
              <X className="h-5 w-5" />
            </Button>
          </div>
        )}
        <nav
          className="sidebar-nav-v2"
          aria-label="Navegação principal"
          onClick={event => { if (isMobile && event.target.closest('a')) toggleMenu?.(); }}
        >
          <SidebarMenuItems isCompact currentPath={location.pathname} />
        </nav>
      </div>
    </div>
  );

  const contextualInbox = location.pathname === '/conversas' && !!new URLSearchParams(location.search).get('assistant_id');
  if (!isMobile && contextualInbox) return null;
  if (!isMobile) return sidebar;

  return (
    <DialogPrimitive.Root open={menuOpen} onOpenChange={open => { if (!open) toggleMenu?.(); }}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 bg-black/40" style={{ zIndex: 'var(--z-modal-backdrop)' }} />
        <DialogPrimitive.Content
          asChild
          aria-describedby={undefined}
          onCloseAutoFocus={event => {
            event.preventDefault();
            document.getElementById('partner-menu-toggle')?.focus();
          }}
        >
          {sidebar}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};

export default MainSidebar;
